export const AttributeNames = {
    amount: 'amount',
    applicantGovernmentId: 'applicantGovernmentId',
    coapplicantGovernmentId: 'coapplicantGovernmentId',
    applicantAccomodationCost: 'applicantAccomodationCost',
    applicantCreditStatusConsent: 'applicantCreditStatusConsent',
};
